export const formErrors = errors => {
  const errorObj = {};

  errors?.map(err => {
    errorObj[err.attribute] = err.error;
  });

  return errorObj;
};
